/* eslint-disable @typescript-eslint/no-explicit-any -- legacy stuffing PDF shapes */
import { RenderPage } from "components/Local/FooterNav/FooterNav";
import { PdfDocument } from "components/Local/PdfDocument/PdfDocument";
import { saveAs } from "file-saver";
import { ResponseContainer } from "store";
import { chunk, makeId } from "utils/helper";
import { convertUnits, getProductsValues, ProductsValueType, typeToString } from "utils/utils";

import { pdf } from "@react-pdf/renderer";

type ExportStuffingPdfArgs = {
  result: ResponseContainer[];
  cargoAttributes: any;
  images: Record<string, string>;
  options: any;
  user?: any;
  containerUid?: string;
};

export const buildStuffingPdfPages = ({
  result,
  cargoAttributes,
  images,
  options,
  containerUid,
}: Omit<ExportStuffingPdfArgs, "user">): RenderPage[] => {
  const pages: RenderPage[] = [];
  const containers = containerUid ? result.filter((item) => item.uid === containerUid) : result;

  containers.forEach((item: ResponseContainer) => {
    const FIRST_PAGE_LENGTH = 34;
    const key: string = String(item.general.cargoWeight) + item.attr.type;
    const products = getProductsValues(item.general.items, cargoAttributes);

    pages.push({
      key,
      page: 1,
      items: products.slice(0, FIRST_PAGE_LENGTH),
      firstPageData: {
        title: typeToString(item.attr.type),
        image: images[item.uid],
        qty: item.qty,
        itemQty: item.general.itemQty,
        cargoVolume: +(
          options.lengthUnits === "mm" ? item.general.cargoVolume / 1_000_000_000 : item.general.cargoVolume
        ).toFixed(0),
        cargoWeight: +convertUnits(item.general.cargoWeight, options.weightUnits).toFixed(0),
        lengthUnits: options.lengthUnits === "mm" ? "m" : options.lengthUnits,
      },
    });

    chunk(products.slice(FIRST_PAGE_LENGTH), 36).forEach((group: ProductsValueType[], index: number) => {
      pages.push({
        key,
        page: index + 2,
        items: group,
        firstPageData: null,
      });
    });
  });

  return pages;
};

export const exportStuffingPdf = async ({
  result,
  cargoAttributes,
  images,
  options,
  user,
  containerUid,
}: ExportStuffingPdfArgs) => {
  const pages = buildStuffingPdfPages({
    result,
    cargoAttributes,
    images,
    options,
    containerUid,
  });

  if (!pages.length) return;

  const blob = await pdf(<PdfDocument data={pages} options={options} user={user} />).toBlob();
  await saveAs(blob, "stuffing_" + makeId(6) + ".pdf");
};
